export default {
  trackRoomClicked({ dispatch, state }, payload) {
    App.track.roomCardClick({
      roomId: payload.room.room_id,
      context: 'search_list',
      tagSlug: state.eventTypeSlug,
      page: +state.page,
      position: +payload.index + 1,
      photoIndex: payload.photoIndex,
      photoUrl: payload.photoUrl,
      totalPhotos: payload.room.photos.length,
    });

    dispatch('trackRoomClick', {
      roomId: payload.room.room_id,
      venueId: payload.room.venue_id,
      section: 'search_page_listing',
      element: 'room_tile',
      elementValue: payload.room.room_id,
      position: +payload.index + 1,
    });

    dispatch('trackGA4Interaction', {
      section: 'list',
      interaction: 'click',
      element: 'room',
      elementValue: payload.room.room_id,
    });

    dispatch('trackVisibleRoomsAddRoom', payload.room.room_id);
  },
  roomCarouselTrackArrowClick({ state, dispatch }, payload) {
    App.track.roomCardCarouselArrowClick({
      roomId: payload.room.room_id,
      context: 'search_list',
      tagSlug: state.eventTypeSlug,
      position: +payload.index + 1,
      page: +state.page,
      photoIndex: payload.photoIndex,
      photoUrl: payload.photoUrl,
      totalPhotos: payload.room.photos.length,
      arrowDirection: payload.arrowDirection,
      photoUrlAfter: payload.photoUrlAfter,
    });

    dispatch('trackGA4Interaction', {
      section: 'list',
      interaction: payload.arrowDirection === 'left' ? 'photo_prev' : 'photo_next',
      element: 'room',
      elementValue: payload.room.room_id,
    });
  },
};
